export const numberFormat = (number, x) => {
    const re = `\\d(?=(\\d{${x || 3}})+$)`;
    return (`${number}`).replace(new RegExp(re, 'g'), '$&,');
};

export const numberCutFormat = (number) => {
    let formattedNumber = `${number}`;

    if (number >= 10000) {
        formattedNumber = `${Math.round(number / 1000)}`;
        formattedNumber = formattedNumber.replace(/(\d+)(\d)/, '$1.$2만').replace(/\.0/g, '');
        return formattedNumber;
    }

    if (number > 0 && number < 10000) {
        return numberFormat(number);
    }

    if (number === 0) {
        return '';
    }

    return formattedNumber;
};

export const changeYearFormat = (date, format) => {
    let newFormat = format;

    if (/(y+)/.test(format)) {
        newFormat = format.replace(
            RegExp.$1,
            (`${date.getFullYear()}`).substr(4 - RegExp.$1.length)
        );
    }

    return newFormat;
};

export const changeDateFormat = (date, format, regex, regexText) => {
    let newFormat = format;

    if (new RegExp(`(${regex})`).test(newFormat)) {
        newFormat = newFormat.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? regexText
                : (`00${regexText}`).substr((`${regexText}`).length)
        );
    }

    return newFormat;
};

const formatFunc = (date, format) => {
    let newFormat = format;

    const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dateRegexTexts = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds(),
        N: MONTH_NAMES[date.getMonth()],
    };

    newFormat = changeYearFormat(date, newFormat);

    Object.keys(dateRegexTexts).forEach((dateRegexKey) => {
        const dateRegexValue = dateRegexTexts[dateRegexKey];
        newFormat = changeDateFormat(date, newFormat, dateRegexKey, dateRegexValue);
    });

    return newFormat;
};

export const DateFormat = (date, format) => formatFunc(date, format);
